import React, { useState, useEffect } from 'react';
import { UserService } from '@services/index';
import { useSnackbar } from '@components/utilities/SnackbarProvider';

async function updateEntity(payload, Entity) {
  const entityService = new Entity();
  const entityResponse = await entityService.update(payload);

  if (!entityResponse || !entityResponse.result) {
    return null;
  }

  return entityResponse;
}

const UserBlock = (props) => {
  const { selectedEntity, onUpdatedEntity, setIsOpen } = props;
  const { openSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const confirmOnClick = async () => {
    try {
      setIsLoading(true);
      const status = { id: 4, name: 'blocked', title: 'Bloqueado' };
      const response = await updateEntity(
        { identity: selectedEntity.id, status },
        UserService,
      );

      if (!response || !response.success) {
        openSnackbar('Ocurrio un error al bloquear', 'error');
        return;
      }

      onUpdatedEntity({ ...selectedEntity, status });
      setIsOpen(false);
    } catch (error) {
      openSnackbar('Ha ocurrido un error', 'error');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const returnOnClick = () => {
    setIsOpen(false);
  };

  return (
    <section className="col-12 mx-auto d-block">
      <div className="card card-body">
        <article className="container pt-2 text-center">
          <h2 className="mb-3">Bloquear a {selectedEntity.firstname}</h2>
          <p>¿Estás seguro de que quieres bloquear?</p>
          <div>
            {isLoading ? (
              <button className="btn btn-primary" disabled type="button">
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            ) : (
              <>
                <button
                  className="btn btn-primary mr-2"
                  onClick={confirmOnClick}
                >
                  <i className="fe-shield-off"></i> Bloquear
                </button>
                <button
                  className="btn btn-light btn-action ms-2"
                  onClick={returnOnClick}
                >
                  <i className="fe-x"></i> Cancelar
                </button>
              </>
            )}
          </div>
        </article>
      </div>
    </section>
  );
};

export default UserBlock;
